// typescript
import React from 'react';
import { FieldErrors } from 'react-hook-form';
import classNames from 'classnames';

export const FieldError: React.FC<{ message: string; className?: string }> = ({ message, className }) => (
  <p className={classNames('text-sm text-[#e53e3e]', className)}>{message}</p>
);

function getByPath(obj: any, path: string) {
  if (!obj) return undefined;
  const parts = String(path).match(/[^.[\]]+/g) || [];
  let acc: any = obj;

  for (const part of parts) {
    if (acc == null) return undefined;

    if (Array.isArray(acc)) {
      // 若 path segment 是數字 -> 當作索引
      if (/^\d+$/.test(part)) {
        acc = acc[Number(part)];
      } else {
        // 否則在陣列中找第一個含該 key 的項目
        const found = acc.find((item: any) => item && Object.prototype.hasOwnProperty.call(item, part));
        acc = found ? found[part] : undefined;
      }
    } else {
      acc = acc[part];
    }
  }

  return acc;
}

type HookFormErrorProps = {
  errors?: FieldErrors<any> | any;
  name: string;
  className?: string;
};

export const HookFormError: React.FC<HookFormErrorProps> = ({ errors, name, className }) => {
  const err = getByPath(errors, name);
  if (!err) return null;

  const message =
    typeof err.message === 'string'
      ? err.message
      : err.types
      ? Object.values(err.types).join(', ')
      : typeof err.type === 'string'
      ? err.type
      : JSON.stringify(err);

  return <FieldError message={message} className={className} />;
};
